// These need to go in a global CSS file. Please note that the paths to the font files in the url() function of the @font-face rule should be relative to the CSS file. Also, the font names in the customFontsToLoad object should match the font-family names specified in the @font-face rule.
// @font-face {
//   font-family: 'SIFONN_PRO';
//   src: url('../../assets/fonts/SIFONN_PRO.ttf') format('truetype');
// }

// @font-face {
//   font-family: 'SIFONN_BASIC_OUTLINE';
//   src: url('../../assets/fonts/SIFONN_BASIC_OUTLINE.otf') format('opentype');
// }

// @font-face {
//   font-family: 'Raleway';
//   src: url('../../assets/fonts/Raleway.ttf') format('truetype');
// }


export const customFontsToLoad = {
  spaceGroteskLight: "'Space Grotesk Light', sans-serif",
  spaceGroteskRegular: "'Space Grotesk Regular', sans-serif",
  spaceGroteskMedium: "'Space Grotesk Medium', sans-serif",
  spaceGroteskSemiBold: "'Space Grotesk SemiBold', sans-serif",
  spaceGroteskBold: "'Space Grotesk Bold', sans-serif",
  SIFONN_PRO: "'SIFONN_PRO', sans-serif",
  SIFONN_BASIC_OUTLINE: "'SIFONN_BASIC_OUTLINE', sans-serif",
  Raleway: "'Raleway', sans-serif"
};

const fonts = {
  spaceGrotesk: {
    // Cross-platform Google font.
    light: "spaceGroteskLight",
    normal: "spaceGroteskRegular",
    medium: "spaceGroteskMedium",
    semiBold: "spaceGroteskSemiBold",
    bold: "spaceGroteskBold",
  },
  helveticaNeue: {
    // iOS only font.
    thin: "HelveticaNeue-Thin",
    light: "HelveticaNeue-Light",
    normal: "Helvetica Neue",
    medium: "HelveticaNeue-Medium",
  },
  courier: {
    // iOS only font.
    normal: "Courier",
  },
  sansSerif: {
    // Android only font.
    thin: "sans-serif-thin",
    light: "sans-serif-light",
    normal: "sans-serif",
    medium: "sans-serif-medium",
  },
  monospace: {
    // Android only font.
    normal: "monospace",
  },
  SIFONN_PRO: {
    normal: "SIFONN_PRO",
    outline: "SIFONN_BASIC_OUTLINE"
  },
  Raleway: {
    normal: "Raleway"
  }
}

export const typography = {
  /**
   * The fonts are available to use, but prefer using the semantic name.
   */
  fonts,
  /**
   * The primary font. Used in most places.
   */
  primary: fonts.spaceGrotesk,
  /**
   * An alternate font used for perhaps titles and stuff.
   */
  secondary: fonts.helveticaNeue,
  /**
   * Lets get fancy with a monospace font!
   */
  code: fonts.courier,
   /**
   * The custom font.
   */
   custom: fonts.SIFONN_PRO,
}
